import React from 'react';
import { useFormContext } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Tippy from '@tippyjs/react';
import useStore from '../../hooks/useStore';

function SaleFooter({
    isInvoice00_1,
    onSubmit,
    onSubmitDraft,
    handlePrint,
    handlePrintAndSave,
    onError,
    onChangeSendAsPendingPayment,
}) {
    const { t } = useTranslation();
    const { register, handleSubmit } = useFormContext();
    const selectedCompany = useStore(s => s.selectedCompany);
    const noSubscriptionKey = !isInvoice00_1 && !selectedCompany?.myDataToken;

    return (
        <div className="card footer salefooter">
            <div className="salefooter-inner">

                <div className="salefooter-secondary">
                    {!isInvoice00_1 && (
                        <button
                            type="button"
                            onClick={handleSubmit(onSubmitDraft, onError)}
                            className="btn salefooter-draft-btn"
                        >
                            <i className="fa fa-floppy-o"></i>
                            <span>{t("saveAsDraft")}</span>
                        </button>
                    )}
                    <button
                        title={t("printbtnInfo")}
                        onClick={handlePrint}
                        className="btn salefooter-preview-btn"
                    >
                        <i className="fa fa-eye"></i>
                        <span>{t("printPreview")}</span>
                    </button>
                </div>

                <div className="salefooter-primary">
                    <Tippy disabled={!noSubscriptionKey} trigger="mouseenter" content={<span className="tooltip-skin">{t("noSubscriptionKey")}</span>}>
                        <span>
                            <button type="button" onClick={handleSubmit(onSubmit, onError)} disabled={noSubscriptionKey} className="btn salefooter-publish-btn">
                                <i className="fa fa-paper-plane"></i>
                                <span>{isInvoice00_1 ? t("Save") : t("Publication")}</span>
                            </button>
                        </span>
                    </Tippy>
                    <Tippy disabled={!noSubscriptionKey} trigger="mouseenter" content={<span className="tooltip-skin">{t("noSubscriptionKey")}</span>}>
                        <span>
                            <button
                                onClick={handleSubmit(handlePrintAndSave, onError)}
                                disabled={noSubscriptionKey}
                                className="btn salefooter-publish-print-btn"
                            >
                                <i className="fa fa-print"></i>
                                <span>{isInvoice00_1 ? t("printPreviewWithSave") : t("PublicationAndPrint")}</span>
                            </button>
                        </span>
                    </Tippy>
                </div>

                {/* <div className="salefooter-options">
                    <label className="salefooter-option-label">
                        <input
                            name="sendAsPendingPayment"
                            type="checkbox"
                            {...register('sendAsPendingPayment', { required: false })}
                            onChange={onChangeSendAsPendingPayment}
                            className="form-check-input"
                        />
                        <span>{t("sendAsPendingPayment")}</span>
                        <Tippy trigger="click" content={<span className="tooltip-skin">{t("transmissionTypeInfo")}</span>}>
                            <i className="fa fa-info-circle infoicon" style={{ marginLeft: 4 }}></i>
                        </Tippy>
                    </label>
                </div> */}

            </div>
        </div>
    );
}

export default SaleFooter;
